import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listSalas:[],
};
export const mutations = {
  GET_SALAS({ context }, salas) {
    let salas_array = [];
    Object.entries(salas).forEach(([key, val]) => salas_array.push(val));
    return (state.listSalas = salas_array);
  },
};
export const actions = {
  GET_SALAS({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_SALAS", response.data.data.salas);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  GET_SALA({ commit }, data) { //axios, mandar parametros para post
    // console.log(data);
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data);
          // commit("SET_LOADING", false);
          // commit("GET_SALA", response.data.data.sala);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },

};

export const getters = {//leer datos
  listSalas: state => state.listSalas,
};
